export default "__VITE_PUBLIC_ASSET__8f9d486b__"